var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.chartData.length)?_c('div',{staticClass:"chart-wrapper"},[_c(_setup.MobileLineBar,{attrs:{"chartOptions":{
			grid: { top: 16 },
			legend: { show: false }
		},"seriesData":_setup.chartData,"tooltip-label":_vm.$t('enterprise.total-of-holdings'),"legends":[_vm.$t('enterprise.total-of-holdings')],"timeFormatter":_vm.timeFormatter,"custom-style":"fund_holding"},on:{"data-checked":_setup.onDataChecked}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }